import DemoBadge from '@/components/feature/DemoBadge';

type Tier = {
  name: string;
  placement: string;
  price: string;
  featured?: boolean;
  items: string[];
};

const TIERS: Tier[] = [
  {
    name: 'Presenting Sponsor',
    placement: 'Front page & hero',
    price: 'Sample package',
    featured: true,
    items: [
      'Your brand on the featured story cover',
      'Mention in the homepage sponsor strip',
      'Logo on every newsletter send',
      'Category exclusivity for the season',
    ],
  },
  {
    name: 'Beat Sponsor',
    placement: 'One content pillar',
    price: 'Sample package',
    items: [
      'Presenting sponsor of one beat',
      'Landing-page branding for that pillar',
      'Quarterly spotlight article',
    ],
  },
  {
    name: 'Calendar & Events',
    placement: 'Tournaments & events',
    price: 'Sample package',
    items: [
      'Presenting sponsor of the calendar',
      'Featured sponsored tournament placement',
      'Signage mention on event pages',
    ],
  },
  {
    name: 'Newsletter Sponsor',
    placement: 'Weekly Digest / Tee-Time Scoop',
    price: 'Sample package',
    items: [
      'One sponsored slot per send',
      'Highest retention placement',
      'Ideal for repeat monthly buys',
    ],
  },
];

export default function SponsorPackages() {
  return (
    <section className="bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <p className="font-label uppercase tracking-[0.28em] text-xs text-primary-600 font-semibold">Packages</p>
        <DemoBadge label="Sample packages" />
      </div>
      <h2 className="font-heading font-bold text-4xl md:text-6xl text-foreground-950 leading-[1.02]">Ways to sponsor</h2>
      <p className="mt-4 text-foreground-600 max-w-2xl">Four tiers built for local businesses — from a season-long presenting partnership to a single newsletter slot. Package details shown here are illustrative.</p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        {TIERS.map((t) => (
          <article key={t.name} className={`flex flex-col rounded-lg p-6 md:p-7 border ${t.featured ? 'bg-foreground-950 border-foreground-950 text-background-50' : 'bg-background-50 border-background-200 text-foreground-950'}`}>
            <span className={`inline-flex w-11 h-11 rounded-md items-center justify-center text-2xl ${t.featured ? 'bg-accent-500 text-foreground-950' : 'bg-primary-100 text-primary-600'}`}>
              <i className="ri-award-line"></i>
            </span>
            <h3 className="mt-5 font-heading font-bold text-2xl leading-tight">{t.name}</h3>
            <p className={`mt-1 font-label uppercase tracking-widest text-[11px] ${t.featured ? 'text-accent-400' : 'text-foreground-500'}`}>{t.placement}</p>
            <ul className="mt-5 space-y-2.5 flex-1">
              {t.items.map((i) => (
                <li key={i} className="flex items-start gap-2 text-sm">
                  <span className={`w-5 h-5 flex items-center justify-center shrink-0 ${t.featured ? 'text-accent-400' : 'text-primary-500'}`}><i className="ri-check-line"></i></span>{i}
                </li>
              ))}
            </ul>
            <p className={`mt-6 pt-4 border-t font-label uppercase tracking-wide text-xs ${t.featured ? 'border-foreground-700 text-background-300' : 'border-background-200 text-foreground-500'}`}>{t.price}</p>
          </article>
        ))}
      </div>
    </section>
  );
}